import axios from "../axios-auth";
import orginal_axios from "axios";

export const accountReceivableService = {
    getAccountReceivableList,
    getAllAccountReceivableList,
    getAccountReceivableDetail,
    showWindowDialog,
    exportAllAccountReceivableDetailExcel,
    saveAccountReceivable,
    getCreditAmountAndRemainingAmount,
    getCashReceiptListingByDate,
    getAllCashReceiptListingByDate,
    getAccountReceivableAdvancedTypeReport,
    getAllAccountReceivableAdvancedTypeReport,
    getAccountReceivableReportByCustomer,
    getAllAccountReceivableReportByCustomer,
    getAccountReceivableReportByCustomerSummary,
    getAccountReceivableReportByCustomerPrint,
    getAccountReceivableReportByCustomerExcelExport,
    getSaleAmouontDetail,
    getSaleDiscountAmouontDetail,
    getSaleReturnAmouontDetail,
    getSaleReturnDiscountAmouontDetail,
    getSaleExpenseAmouontDetail,
    getCreditReceivedDetail,
    getAdvancedAmountDetail,
    getAccountReceivableFinanceReportExcelExport,
    getAccountReceivableFinanceReportSummary,
    getAccountReceivableFinanceReportPrint,
    getUnpaidCustomerAdvancedTypeAccountReceivableList,
};

function getAccountReceivableList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.arType) {
        params["arType"] = searchParams.arType;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.chequeNo) {
        params["chequeNo"] = searchParams.chequeNo;
    }
    return axios.get("/auth/account-receives", { params });
}

function getAllAccountReceivableList(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.arType) {
        params["arType"] = searchParams.arType;
    }

    return axios.get("/auth/account-receives", { params });
}

function getAccountReceivableDetail(id) {
    return axios.get("/auth/account-receive/" + id);
}

function getCreditAmountAndRemainingAmount(fromDate, toDate, customerId, shopId, saleInvoice) {
    let params = {};

    if (fromDate) {
        params["fromDate"] = fromDate;
    }
    if (toDate) {
        params["toDate"] = toDate;
    }
    if (customerId) {
        params["customerId"] = customerId;
    }
    if (shopId) {
        params["shopId"] = shopId;
    }
    if (saleInvoice) {
        params["saleInvoice"] = saleInvoice;
    }

    return axios.get("/auth/account-receive-creditbalance", { params });
}

function saveAccountReceivable(accountReceivable) {
    if (!accountReceivable.id) {
        // new damageHeader
        return axios.post("/auth/account-receive", accountReceivable);
    } else {
        // edit
        return axios.put("/auth/account-receive", accountReceivable);
    }
}

function exportAllAccountReceivableDetailExcel(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.arType) {
        params["arType"] = searchParams.arType;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.chequeNo) {
        params["chequeNo"] = searchParams.chequeNo;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/all-account-receivable-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function showWindowDialog(blob, fileName) {
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
        return;
    }
    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob);
    var link = document.createElement(fileName);
    link.href = data;
    link.download = fileName + ".pdf";
    window.open(link.href, fileName, "width=500,height=500");

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
}

function getCashReceiptListingByDate(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/cash-receipt-listing-by-date", { params });
}

function getAllCashReceiptListingByDate(searchParams) {
    let params = {};
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/cash-receipt-listing-by-date", { params });

}

function getAccountReceivableAdvancedTypeReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/account-receivable-advanced-type-report", { params });
}
function getAllAccountReceivableAdvancedTypeReport(searchParams) {
    let params = {};
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.issueNo) {
        params["fromDate"] = searchParams.issueNo;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/account-receivable-advanced-type-report", { params });

}

function getAccountReceivableReportByCustomer(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    return axios.get("/auth/account-receivable-report-by-customer", { params });
}

function getAllAccountReceivableReportByCustomer(searchParams) {
    let params = {};
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    return axios.get("/auth/account-receivable-report-by-customer", { params });

}

function getAccountReceivableReportByCustomerSummary(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    return axios.get("/auth/account-receivable-report-by-customer-summary", { params });
}

function getAccountReceivableReportByCustomerPrint(searchParams) {
    let params = {};
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    return axios.get("/auth/account-receivable-report-by-customer-print", { params });
}

function getAccountReceivableReportByCustomerExcelExport(searchParams) {
    let params = {
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/account-receivable-report-by-customer-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAccountReceivableFinanceReportSummary(searchParams) {
    let params = {
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    return axios.get("/auth/account-receivable-finance-report-summary", { params });
}

function getSaleAmouontDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return axios.get("/auth/finance-sale-amount-details", { params });
}

function getSaleDiscountAmouontDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return axios.get("/auth/finance-sale-discount-amount-details", { params });
}

function getSaleReturnAmouontDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return axios.get("/auth/finance-sale-return-amount-details", { params });
}

function getSaleReturnDiscountAmouontDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return axios.get("/auth/finance-sale-return-discount-amount-details", { params });
}

function getSaleExpenseAmouontDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return axios.get("/auth/finance-sale-expense-amount-details", { params });
}

function getCreditReceivedDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return axios.get("/auth/finance-credit-received-amount-details", { params });
}

function getAdvancedAmountDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return axios.get("/auth/finance-advanced-amount-detail", { params });
}

function getAccountReceivableFinanceReportExcelExport(searchParams, detailType) {
    let params = {
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (detailType) {
        params["detailType"] = detailType;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/account-receivable-finance-report-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAccountReceivableFinanceReportPrint(searchParams, page, size, sortedBy, detailType) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (detailType) {
        params["detailType"] = detailType;
    }

    return axios.get("/auth/account-receivable-finance-report-print", { params });
}

function getUnpaidCustomerAdvancedTypeAccountReceivableList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.customerId) {
        params["customerId"] = searchParams.customerId;
    }

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.remark) {
        params["remark"] = searchParams.remark;
    }

    return axios.get("/auth/unpaid-account-receivable-advance", { params });
}